
import { useUnit } from "effector-react"

import { $assetCategories, $isFetchingAssetCategories, fetchAssetCategories } from "stores/assetCategories"

export default function useAssetCategories() {
    const assetCategories = useUnit($assetCategories)
    const isFetchingAssetCategories = useUnit($isFetchingAssetCategories)

    return {
        assetCategories,
        isFetchingAssetCategories,
        fetchAssetCategories,
    }
}
